
// import './faculty.css';
import facult1 from '../../images/faculty1.png';
import { useState, useEffect } from 'react';
// import { Facultdata } from './slidedata';
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Facultdata } from '../../data';
import parse from "html-react-parser";
import axios from "axios";


const Faculty = (props) => {


    console.log("kjcnkjdfnfkn",props.data)
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, background: "#05A474" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, background: "#05A474" }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        // dots: true,
        infinite: false,
        autoplay: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        loop: true,
        margin: 10,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        // responsive: [
        //     {
        //         breakpoint: 1320,
        //         settings: {
        //             slidesToShow: 3,
        //             slidesToScroll: 2,
        //             infinite: true,
        //             autoplay: true,
        //             speed: 300,
        //             loop: true,
        //             margin: 10,
        //         },
        //     },
        //     {
        //         breakpoint: 1024,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 2,
        //             infinite: true,
        //             autoplay: true,
        //             speed: 300,
        //             loop: true,
        //             margin: 10,
        //         },
        //     },
        //     {
        //         breakpoint: 600,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 2,
        //             infinite: true,
        //             loop: true,
        //             autoplay: true,
        //             speed: 300,
        //             initialSlide: 2,
        //         },
        //     },
        //     {
        //         breakpoint: 480,
        //         settings: {
        //             slidesToShow: 1.2,
        //             slidesToScroll: 1,
        //         },
        //     },
        // ],
    };





    // const [Data, setData] = useState(null)

    // async function fetchData() {
    //     try {
    //         const response = await axios.get(`https://obelabs.onrender.com/user/institute/getinstitute/${props.id}`)
    //         setData(response.data)
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    // useEffect(() => {
    //     fetchData();
    // }, [])

    return props.data !== null && (

        <>

            <div className='slide-main faculty container-fluid d-none d-md-block p-0'>

                <Slider {...settings}>
                    {props.data ? props.data.map((val, key) => (
                        <div className="main-con py-3"  key={key}>
                            <div className="cards">
                                <div className="image d-flex" >
                                    <img src={facult1} alt={facult1} />
                                    <h5>{val.name}</h5>
                                </div>
                                <p>{parse(val.description)}</p>
                                <hr />
                                <h6>Professor, {val.subject}</h6>
                            </div>
                        </div>
                                )): ""}
                </Slider>
            </div>

        </>

    )


}

export default Faculty